import React, { memo, useMemo } from 'react';
import { useGroupBy } from '../group-by';
import { useChildrenLoader } from './children-loader';
import GroupsLoader from './groups-loader';
import HierarchyLoader from './hierarchy-loader';

const Hierarchy = () => {
	const { childrenLoader } = useChildrenLoader();
	const [groupByFieldId] = useGroupBy();

	// avoid re-fetching children when Hierarchy component re-renders
	const childItemsLoader = useMemo(() => childrenLoader, [childrenLoader]);

	const shouldGroupItems = groupByFieldId != null;

	return (
		<>
			{shouldGroupItems ? <GroupsLoader /> : <HierarchyLoader />}
			{childItemsLoader}
		</>
	);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default memo<Record<any, any>>(Hierarchy);
